export default __webpack_public_path__ + "static/logo-100-d11bcd66b95a45ac82906c0a17f198eb.svg";